export const actions = [
    'ViewDashboard',
    'ViewProfile',

    'ListMeteringRecords',
    'GetMeteringRecord',
    'CreateMeteringRecord',
    'UpdateMeteringRecord',
    'DeleteMeteringRecord',

    'ListNotificationSubscriptions',
    'GetNotificationSubscription',
    'CreateNotificationSubscription',
    'UpdateNotificationSubscription',
    'DeleteNotificationSubscription',

    'ListOffers',
    'GetOffer',
    'CreateOffer',
    'UpdateOffer',
    'DeleteOffer',

    'ListProducts',
    'GetProduct',
    'CreateProduct',
    'UpdateProduct',
    'DeleteProduct',

    'ListRegistrations',
    'GetRegistration',
    'CreateRegistration',
    'UpdateRegistration',
    'DeleteRegistration',
    'SimulateRegistration',

] as const;

// FNP-1934: the union of every action this app checks. A check that names an
// action outside this list fails to compile instead of silently denying.
export type RbacAction = typeof actions[number];

export const isRbacAction = (value: unknown): value is RbacAction =>
    typeof value === 'string' && (actions as readonly string[]).includes(value);
